import React, { useState } from "react";
import toast from "react-hot-toast";
import {
  getCurrentFYByDate,
  minutesToHHMM,
  secondsToHHMM,
  timeToSeconds,
} from "../../Utilitie";
import { data } from "react-router-dom";

const NKJExaminationIns = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;

  const [globalDate, setGlobalDate] = useState(
    new Date().toISOString().slice(0, 7),
  );
  const fyData = getCurrentFYByDate(globalDate) || {};

  const [entries, setEntries] = useState([
    {
      EX_TY_CC: "",
      EX_TY_PREMIUM: "",
      EX_TY_INTENSIVE: "",
      TOTAL_RAKES: "",
      TOTAL_EXAM_TIME: "",
      HOUR: "",
      MINUTE: "",
      AVG_EXAM_TIME: "",
      SM_MR_Sick_inc_B_Van: "",
      SM_ROH: "",
      SM_POH_inc_B_Van: "",
      SM_NPOH: "",
      SM_Gap_or_Position_Change: "",
      SICK_MR_SER_INTER_MIX: "",
      SICK_MR_SER_BMBS: "",
      SICK_MR_SER_TOTAL: "",
      SICK_MR_SER_Avg_Shunt_per_Rake: "",
      Det_Avg_Release_to_Departure: "",
      Det_Avg_Arrival_to_Departure: "",
    },
  ]);

  const keys = [
    "EX_TY_CC",
    "EX_TY_PREMIUM",
    "EX_TY_INTENSIVE",
    "TOTAL_RAKES",
    "TOTAL_EXAM_TIME",
    "HOUR",
    "MINUTE",
    "AVG_EXAM_TIME",
    "SM_MR_Sick_inc_B_Van",
    "SM_ROH",
    "SM_POH_inc_B_Van",
    "SM_NPOH",
    "SM_Gap_or_Position_Change",
    "SICK_MR_SER_INTER_MIX",
    "SICK_MR_SER_BMBS",
    "SICK_MR_SER_TOTAL",
    "SICK_MR_SER_Avg_Shunt_per_Rake",
    "Det_Avg_Release_to_Departure",
    "Det_Avg_Arrival_to_Departure",
  ];
  const handleChange = (rowIndex, key, value) => {
    setEntries((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;

        const updated = { ...row };

        updated[key] = Number(value) || 0;

        // /////////////////total Rake//////////////////////

        const EX_TY_CC = Number(updated.EX_TY_CC) || 0;
        const EX_TY_PREMIUM = Number(updated.EX_TY_PREMIUM) || 0;
        const EX_TY_INTENSIVE = Number(updated.EX_TY_INTENSIVE) || 0;

        // //////////////////Total sick////////////////

        const T1 = Number(updated.SM_MR_Sick_inc_B_Van) || 0;
        const T2 = Number(updated.SM_ROH) || 0;
        const T3 = Number(updated.SM_POH_inc_B_Van) || 0;
        const T4 = Number(updated.SM_NPOH) || 0;
        const T5 = Number(updated.SM_Gap_or_Position_Change) || 0;
        const T6 = Number(updated.SICK_MR_SER_INTER_MIX) || 0;
        const T7 = Number(updated.SICK_MR_SER_BMBS) || 0;

        // ///////////////////Total Exam Time ////////////////////////

        const HOUR = Number(updated.HOUR) || 0;
        const MINUTE = Number(updated.MINUTE) || 0;

        ///////////////////////////////////////////////////

        const total = Math.abs(EX_TY_CC + EX_TY_PREMIUM + EX_TY_INTENSIVE);
        const SickTotal = Math.abs(T1 + T2 + T3 + T4 + T5 + T6 + T7);
        const totalExamTime = Math.abs(
          (Number(HOUR) || 0) * 3600 + (Number(MINUTE) || 0) * 60,
        );

        updated.TOTAL_RAKES = total;
        updated.SICK_MR_SER_TOTAL = SickTotal;
        updated.TOTAL_EXAM_TIME = totalExamTime;

        //////////////////////////////////////////////////
        const shuntAvg = (SickTotal / total).toFixed(2);
        updated.SICK_MR_SER_Avg_Shunt_per_Rake = shuntAvg;
        const totalExamAvg = (totalExamTime / total).toFixed(2);
        updated.AVG_EXAM_TIME = totalExamAvg;

        ///////////////////////////////////////////////////

        if (
          key === "Det_Avg_Release_to_Departure" ||
          key === "Det_Avg_Arrival_to_Departure"
        ) {
          updated[key] = timeToSeconds(value);
        } else {
          updated[key] = value;
        }

        return updated;
      }),
    );
  };

  const addRow = () => {
    setEntries((prev) => [
      ...prev,
      {
        EX_TY_CC: "",
        EX_TY_PREMIUM: "",
        EX_TY_INTENSIVE: "",
        TOTAL_RAKES: "",
        TOTAL_EXAM_TIME: "",
        HOUR: "",
        MINUTE: "",
        AVG_EXAM_TIME: "",
        SM_MR_Sick_inc_B_Van: "",
        SM_ROH: "",
        SM_POH_inc_B_Van: "",
        SM_NPOH: "",
        SM_Gap_or_Position_Change: "",
        SICK_MR_SER_INTER_MIX: "",
        SICK_MR_SER_BMBS: "",
        SICK_MR_SER_TOTAL: "",
        SICK_MR_SER_Avg_Shunt_per_Rake: "",
        Det_Avg_Release_to_Departure: "",
        Det_Avg_Arrival_to_Departure: "",
      },
    ]);
  };

  const removeRow = (index) =>
    setEntries((prev) => prev.filter((_, i) => i !== index));
  const handleClear = () => setEntries([]);

  const handleSubmit = async () => {
    const FinalData = entries.map(({ HOUR, MINUTE, ...rest }) => rest);

    const dataToSend = FinalData.map((entry) => ({
      ...entry,
      F_YEAR: fyData.FY.replace("_", "-") || "",
      A_YEAR: globalDate?.slice(0, 4),
      MONTH: fyData.month.toUpperCase() || "",
    }));
    try {
      const response = await fetch(
        `${urlPrefix}insert/nkj_boxn_examination_and_detention`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(dataToSend),
        },
      );

      const result = await response.json();
      if (!response.ok) throw new Error(result?.message || "HTTP error");

      toast.success("✅ Data uploaded successfully!");
      setEntries([
        {
          EX_TY_CC: "",
          EX_TY_PREMIUM: "",
          EX_TY_INTENSIVE: "",
          TOTAL_RAKES: "",
          TOTAL_EXAM_TIME: "",
          HOUR: "",
          MINUTE: "",
          AVG_EXAM_TIME: "",
          SM_MR_Sick_inc_B_Van: "",
          SM_ROH: "",
          SM_POH_inc_B_Van: "",
          SM_NPOH: "",
          SM_Gap_or_Position_Change: "",
          SICK_MR_SER_INTER_MIX: "",
          SICK_MR_SER_BMBS: "",
          SICK_MR_SER_TOTAL: "",
          SICK_MR_SER_Avg_Shunt_per_Rake: "",
          Det_Avg_Release_to_Departure: "",
          Det_Avg_Arrival_to_Departure: "",
        },
      ]);
    } catch (error) {
      toast.error("❌ Failed to upload data");
      console.error("Upload error:", error);
    }
  };

  const handleDateChange = (value) => {
    setGlobalDate(value);
  };

  return (
    <div className="papaDiv">
      <h5 className="p-2 bg-dark text-white text-center">
        Insert Data in NKJ Examination
      </h5>

      <div className="d-flex justify-content-center align-items-center gap-3 m-3">
        <div>
          <label className="fw-bold me-2">Select Date:</label>
          <input
            type="month"
            className="form-control d-inline-block"
            style={{ width: "180px", fontSize: "0.9rem" }}
            value={globalDate}
            onChange={(e) => handleDateChange(e.target.value)}
          />
        </div>
        <div>
          <span className="badge bg-primary me-2">
            FY: {fyData.FY.replace("_", "-") || "N/A"}
          </span>
          <span className="badge bg-success">
            Month: {fyData.month || "N/A"}
          </span>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped mb-4 text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th colSpan={4}>Examination Type</th>
              <th colSpan={2}>Total Exam Time</th>
              <th colSpan={10}>Sick Type</th>
              <th colSpan={3}>Detention Type</th>
            </tr>
            <tr>
              {keys.map((key, i) =>
                key === "TOTAL_EXAM_TIME" ? null : (
                  <th
                    key={i}
                    style={{
                      maxWidth: "90px",
                      fontSize: "13px",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    {key.replace(/_/g, " ")}
                  </th>
                ),
              )}
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {entries.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {keys.map((key, index) =>
                  key === "TOTAL_EXAM_TIME" ? null : (
                    <td key={index} style={{}}>
                      {key === "HOUR" ? (
                        <input
                          type="number"
                          style={{ minWidth: "40px" }}
                          className="form-control"
                          placeholder="HH"
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "MINUTE" ? (
                        <input
                          type="number"
                          style={{ minWidth: "90px" }}
                          className=" form-control"
                          placeholder="MM"
                          min="0"
                          max="59"
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(
                              rowIndex,
                              key,
                              Math.min(59, Math.max(0, Number(e.target.value))),
                            )
                          }
                        />
                      ) : key === "TOTAL_RAKES" ||
                        key === "SICK_MR_SER_TOTAL" ||
                        key === "SICK_MR_SER_Avg_Shunt_per_Rake" ? (
                        <input
                          disabled
                          className="form-control"
                          type="number"
                          value={row[key] || ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "Det_Avg_Release_to_Departure" ||
                        key === "Det_Avg_Arrival_to_Departure" ? (
                        <input
                          className="form-control"
                          type="time"
                          value={row[key] ? secondsToHHMM(row[key]) : ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : key === "AVG_EXAM_TIME" ? (
                        <input
                          className="form-control"
                          disabled
                          type="time"
                          value={row[key] ? secondsToHHMM(row[key]) : ""}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      ) : (
                        <input
                          type="number"
                          className="form-control"
                          value={row[key]}
                          onChange={(e) =>
                            handleChange(rowIndex, key, e.target.value)
                          }
                        />
                      )}
                    </td>
                  ),
                )}

                <td>
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => removeRow(rowIndex)}
                  >
                    🗑
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center mt-3">
        <button className="btn btn-outline-primary m-2" onClick={addRow}>
          Add Row
        </button>
        <button className="btn btn-outline-danger m-2" onClick={handleClear}>
          Clear
        </button>
        <button className="btn btn-outline-success m-2" onClick={handleSubmit}>
          Upload
        </button>
      </div>
    </div>
  );
};

export default NKJExaminationIns;
